<template>
  <div class="summary-table-block">
    <table class="summary-table-block__table">
      <thead>
        <tr>
          <th
            v-for="column in block.columns"
            :key="column.key"
          >
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in visibleRows"
          :key="row.id || rowIndex(row)"
        >
          <td
            v-for="column in block.columns"
            :key="column.key"
          >
            {{ row[column.key] }}
          </td>
        </tr>
      </tbody>
    </table>

    <div
      v-if="hasMoreRows || hasActions"
      class="summary-table-block__footer"
    >
      <button
        v-if="hasMoreRows"
        type="button"
        class="summary-table-block__view-all"
        @click="emitViewAll"
      >
        {{ $t('copilot.summaryTableViewAll') }}
      </button>

      <ActionButtons
        v-if="hasActions"
        :actions="block.actions"
        @action-click="onActionClick"
      />
    </div>
  </div>
</template>

<script>
import ActionButtons from '@baserow/modules/copilot/components/generative/ActionButtons'

export default {
  name: 'SummaryTableBlock',
  components: {
    ActionButtons,
  },
  props: {
    /**
     * Summary table payload.
     *
     * Suggested shape:
     * - columns: Array<{ key: string, label: string }>
     * - rows: Array<{ id?: string, [columnKey: string]: any }>
     * - maxRows?: number
     * - actions?: GenerativeBlockAction[]
     */
    block: {
      type: Object,
      required: true,
    },
  },
  computed: {
    visibleRows() {
      const rows = this.block.rows || []
      const maxRows = this.block.maxRows || rows.length
      return rows.slice(0, maxRows)
    },
    hasMoreRows() {
      const rows = this.block.rows || []
      const maxRows = this.block.maxRows
      return maxRows != null && rows.length > maxRows
    },
    hasActions() {
      return Array.isArray(this.block.actions) && this.block.actions.length > 0
    },
  },
  methods: {
    rowIndex(row) {
      return (this.block.rows || []).indexOf(row)
    },
    emitViewAll() {
      this.$emit('action-click', { id: 'view_all', intent: 'open_grid' }, this.block)
    },
    onActionClick(action) {
      this.$emit('action-click', action, this.block)
    },
  },
}
</script>

<style scoped lang="scss">
.summary-table-block__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.summary-table-block__table th,
.summary-table-block__table td {
  padding: 4px 6px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  text-align: left;
}

.summary-table-block__table thead {
  background-color: rgba(0, 0, 0, 0.02);
}

.summary-table-block__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}

.summary-table-block__view-all {
  border: none;
  background: none;
  padding: 0;
  font-size: 11px;
  color: #1a73e8;
  cursor: pointer;
}
</style>

